import styled from 'styled-components'

export const StPageLinkWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.Components.Button.Secondary.Border};
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
`
